module.exports = __webpack_public_path__ + "media/new/residential-96-27525520.png";